export enum localStorageConsts {
  language = 'lang',
}
